<table mat-table [dataSource]="itemList" class="mat-elevation gsm-gge-table">
  <!--Art Column-->
  <ng-container matColumnDef="art">
    <th mat-header-cell *matHeaderCellDef>Art *</th>
    <td mat-cell *matCellDef="let item">
      <input
        matInput
        name="art"
        type="text"
        minlength="2"
        required
        gsmAlphanum
        data-test="artInput"
        [(ngModel)]="item.art"
        [disabled]="model?.disabled"
        (blur)="onInputBlur()"
        #art="ngModel"
      />
    </td>
  </ng-container>
  <!--Marke Column-->
  <ng-container matColumnDef="marke">
    <th mat-header-cell *matHeaderCellDef>Marke</th>
    <td mat-cell *matCellDef="let item">
      <input
        matInput
        name="marke"
        type="text"
        minlength="2"
        gsmAlphanum
        data-test="markeInput"
        [(ngModel)]="item.marke"
        [disabled]="model?.disabled"
        (blur)="onInputBlur()"
      />
    </td>
  </ng-container>
  <!--Typenbezeichnung Column-->
  <ng-container matColumnDef="typenbezeichnung">
    <th mat-header-cell *matHeaderCellDef>Typenbezeichnung</th>
    <td mat-cell *matCellDef="let item">
      <input
        matInput
        name="typenbezeichnung"
        type="text"
        minlength="2"
        data-test="typInput"
        [(ngModel)]="item.typenbezeichnung"
        [disabled]="model?.disabled"
        (blur)="onInputBlur()"
      />
    </td>
  </ng-container>
  <!--Notiz Column-->
  <ng-container matColumnDef="notiz">
    <th mat-header-cell *matHeaderCellDef>Notiz</th>
    <td mat-cell *matCellDef="let item">
      <input
        matInput
        name="notiz"
        type="text"
        data-test="notizInput"
        [(ngModel)]="item.notiz"
        [disabled]="model?.disabled"
        (blur)="onInputBlur()"
      />
    </td>
  </ng-container>
  <!--Delete Column-->
  <ng-container matColumnDef="delete">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let item; let i = index">
      <button mat-icon-button (click)="deleteItem(i)" *ngIf="!model?.disabled">
        <mat-icon>delete</mat-icon>
      </button>
    </td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>

<span class="add-item" *ngIf="!model?.disabled" data-test="gsm-ia-table_add" (click)="addItem()">
  <button mat-mini-fab color="primary">
    <mat-icon>add</mat-icon>
  </button>
  <span class="label">Weiteren Eintrag hinzufügen</span>
</span>
